import GenericDB from './generic-db';

export default class PlacesOfServiceDB extends GenericDB {
  constructor() {
    super('placesOfService');
  }

  // Clinic-scoped by a `clinic` field: callers filter reads with a
  // ['clinic', '==', clinicId] constraint and set `clinic` on writes.
}
